<template>
  <div>
    <div class="headbt">
      <span class="zjt" @click="fh"><img src="../../assets/img/zjt.png" ></span>在线咨询&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>

    <div class="rwbt">

      <div class="bwbt_1">
          线上公益咨询记录
          <div class="zixun" @click="tz('/user/zixun')">
            +线上公益咨询
          </div>
      </div>

    </div>
 <div class="rwgl" v-if="all_count== 0  &&  isShow== true">
    <img src="../../assets/img/zwsj.jpg"/>
  </div>
<div class="rwgl"  v-for="item in listdata" >
      <div class="uinfo" >
      	<div class="uinfo_1 ">

      	<ul class="list-group">

          <li class="list-group-item  userliebiao">

          	<div class=" col-sm-4 col-4 col-md-4 leftsj" >
          		咨询人
          	</div>
          	<div class=" col-sm-8 col-8 col-md-8 rwmc rightsj jxz" >
          		{{item.createName}}
          	</div>
          </li>
          <li class="list-group-item  userliebiao">
          	<div class=" col-sm-3 col-3 col-md-3 leftsj" >
               联系方式
             </div>
            <div class=" col-sm-9 col-9 col-md-9 rightsj" >
              	{{item.iphone}}
             </div>
          </li>
      	 <li class="list-group-item  userliebiao">
      		<div class=" col-sm-3 col-3 col-md-3 leftsj" >
      	     咨询内容
      	   </div>
      	   <div class=" col-sm-9 col-9 col-md-9 rightsj jslh jxz"  >
          	{{item.consultationContent}}
      	   </div>
      	</li>
    <!-- <li class="list-group-item  userliebiao">

          <div class=" col-sm-12 col-12 col-md-12 "  style="line-height: 30px;" >
            咨询内容：<br>
          	<div style="margin-top: 5px;" class="jxz zxnr jslh" >{{item.consultationContent}}</div>
           </div>
        </li> -->
        <li class="list-group-item  userliebiao ">
        	<div class=" col-sm-3 col-3 col-md-3 leftsj" >
             咨询时间
           </div>
          <div class=" col-sm-9 col-9 col-md-9 rightsj " >
           	{{item.createTime}}
           </div>
        </li>
        <li class="list-group-item  userliebiao ">
        	<div class=" col-sm-3 col-3 col-md-3 leftsj" >
             回复状态
           </div>
          <div class=" col-sm-9 col-9 col-md-9 rightsj " >

            <div v-if="item.isReply  == 1">
                已回复
            </div>
            <div v-if="item.isReply  == 2">
                未回复
            </div>
           </div>
        </li>
        <li class="list-group-item  userliebiao wdbbk">
          <div class=" col-sm-12 col-12 col-md-12 rightsj jxz" >

        	<div class="kfan ckxq" @click="del(item.id)">
        	  删除
        	 </div>
        	 <div class=" kfan scan"  @click="xq(item)">
        	  	查看详情
        	  </div>
          </div>
        </li>

      	</ul>
      	</div>
      </div>
    </div>
    <div class="jzxyy">
      <div class="djjzxyy" @click="xym"  v-if="xyy == 1 && all_count > 0">
          点击加载下一页
      </div>
      <div class="djjzxyy"  v-if="xyy == 0 && all_count > 0">
          没有更多数据
      </div>

    </div>


    <div class="bkx">

    </div>


  </div>
</template>

<script>
import {wdzx,delzx} from '../../api/baseset'
  export default {
      data() {
        return {
          page:1,
          limit:10,
          listdata:[],
          all_count:0,
          xyy:0,
          isShow:false,

        }
      },
      mounted() {
        this.getdata();
     // this.getsjtjs();
      },
      methods: {

        getdata(){

         this.loading = true
         let param={pageNum:this.page,pageSize:this.limit}
            wdzx(param)
             .then(res => {

               this.loading = false
               if (res.code != 200) {
                 this.$message({
                   type: 'info',
                   message: res.msg
                 })
               } else {

                  this.listdata = this.listdata.concat(res.rows);
                  this.all_count = res.total
                  if(this.limit*this.page < this.all_count){
                    this.xyy = 1;
                  }else{
                    this.xyy = 0;
                  }
               }
               this.isShow = true
             })
             .catch(err => {
               this.loading = false
               this.$message.error('数据加载失败，请稍后再试！')
             })

        },

        // 搜索事件
        search() {
          this.formInline.page = 1
          this.formInline.limit = 10
          this.getdata(this.formInline)
        },
        // 重置搜索
        formReset() {
          this.formInline.key = '';
        },
        shouli() {

        },
        chuli() {
          this.dialogVisible = true;
        },
        tz(url){

          this.$router.push(url);
        },
        fh(){
         window.history.go(-1);
        },
        xym() {
          this.page = this.page+1;
          this.getdata()
        },
        xq(row){

             localStorage.setItem('user_zixun', JSON.stringify(row))
             this.$router.push('/user/zixundetail');
        },
        del(id){
           this.$confirm('确定要删除该条咨询数据？', '温馨提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
                      let param={id:id}
                         delzx(param)
                          .then(res => {
                              this.loading = false
                            if (res.code != 200) {
                              this.$message({
                                type: 'info',
                                message: res.msg
                              })
                            } else {
                              this.$message({
                                type: 'success',
                                message: '操作成功'
                              })
                               this.listdata = []
                              this.getdata()
                            }
                          })
                          .catch(err => {
                            this.loading = false
                            this.$message.error('数据加载失败，请稍后再试！')
                          })

                  }).catch(() => {
                    this.$message({
                      type: 'info',
                      message: '已取消删除'
                    });
                  });
        }
      }
    }
  </script>

<style scoped>
  	body{
  			background-color: #EFEFF4;
  		}

  		.footer {
  		  position: fixed ;
  		  bottom: 0;
  		  width: 100%;
  		  height: 60px; /* 底部栏的高度 */

  		  background-color: white;
  		  display: flex;
  		  border-top: solid 1px #E6EAEC;
       /* border: solid 1px red; */
        margin-left:  0 !important;
  		}
  		.item_list_menu{
  			/* border: solid 1px red; */
  			text-align: center;
  		}
  		.dibumenu{
  			width: 100%;
  			text-align: center;
  			padding-top: 3px;
  		}
  		.dibumenu img{
  			width: 24px;
  			height: 24px;
  		}
  		.xmtitle{
  			text-align: center;
  			font-size: 14px;
  			color: #666666;
  		}
  		.xmtitle_active{
  			color: #00DDA3;
  		}


    .list-group{
    	--bs-list-group-border-radius:0 0 0 0 !important;
    }


    .item_list_menu{
    	/* border: solid 1px red; */
    	text-align: center;
    }
    .userliebiao{
    	display: flex;
    	font-size: 14px;
    	height: auto;
    	padding-top: 5px;
    	padding-bottom: 5px;
    	background-color: white;
    }
    .userinfo{
    	text-align: right;
    }
    .dibuxian{
    	width: 100%;
    	height: 90px;
    }
    .yjt img{
    	width: 24px;
    	height: 24px;
    }

    .bfwrxx_left{
    	text-align: left !important;
    	font-size: 18px  !important;
    	line-height: 40px !important;
    	padding-left: 2% !important;
    }
    .qrbc{
    	width:40%;
    	height: 30px;
    	margin: 0 auto;
    	text-align: center;
    	line-height: 30px;
    	color: white;
    	border-radius: 5px 5px 5px 5px;
    	background-color: #00DDA3;
    	margin-top: 15px;
    	margin-bottom: 10px;
    }
    .uinfo{
    	width: 100%;
    	height: auto;
    	/* padding-top: 5px;
    	padding-bottom: 5px; */
    	background-color: white;
      font-size: 12px;
    }
    .uinfo_1{
    	width: 88%;
    	height: auto;
    	margin: 0 auto;
    }
    .bkx{
      width: 100%;
      height: 80px;
    }
    .list-group{
    	--bs-list-group-border-radius:0 0 0 0 !important;
    }

    .list-group-item{
    	border-radius: 0 0 0 0 ;
    	border: none !important;
    	padding:  0 0 0 0 !important;

    	height: 2.5rem;
    	line-height:2.5rem;
    	font-size: 14px;
    	color: #666666;
    	border-bottom: solid  1px #E6EAEC !important;
    }
    .list-group-item:first-child{
    	border-top-left-radius: 0;
    	border-top-right-radius: 0;

    }
    .uinfo_1{
    	width: 90%;
    	height: auto;
    	margin: 0 auto;
    }
    .userliebiao{
    	display: flex;
    	font-size: 14px;
    	height: auto;

    	background-color: white;
    }

    .form-control{
    	 border: none !important;
    	font-size: 12px;
    	height: 3rem;

    }
    .form-control:focus {
        outline: none;
        border-color: #ccc;
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .xingxing{
    	color:red;
    }
    .rwbt{
      width: 100%;
      height: auto;

      background-color: white;
      margin-top: 15px;
       box-shadow: 2px 2px 2px 2px #ccc,-2px -2px 2px 2px #ccc;
    }
    .rwbtaaa{
       box-shadow: 0 0 0 0 ;
    }
    .bwbt_1{
      width: 92%;
      height: 3rem;
      margin: 0 auto;
      line-height: 3rem;
      /* border: solid 1px #ccc; */
     /* padding-top: -10px; */
      font-size:14px;
      color: black;
      font-weight: bold;

    }
    .bwbt_1::before {
        content: "   ";
        display:inline-block;
        position: relative;
        width: 5px;
          /* background-color: red; */
        border-left:solid 5px #00DDA3;
        height: 25px;
        padding-left: 7px;
        top:5px;
      }
      .bwbt_11{
        width: 92%;
        height: 3rem;
        margin: 0 auto;
        line-height: 3rem;

        font-size:14px;
        color: black;
        font-weight: bold;

      }
      .bwbt_11::before{
        content: "   ";
        display:inline-block;
        position: relative;
        width: 5px;
          /* background-color: red; */
        border-left:solid 5px #FF6712;
        height: 25px;
        padding-left: 7px;
        top:5px;
      }
      .right_sj{
        text-align: right;
      }
      .jxz{
        color: #00DDA3;
        font-weight: bold;
      }
      .lblb{
        height: 120px;
        /* border-right:solid 1px red; */
      }
      .lblb_list{
        width: 90%;
        margin: 0 auto;
        height: auto;
        padding-top:5px;
        padding-bottom: 5px;
        /* border: solid 1px green; */
        display: flex;
      }
      .lblb_1{
        width:94%;

        height: 100px;
        border-radius: 5px 5px 5px 5px;
        box-shadow: 1px 1px 2px 2px #ccc,-1px -1px 2px 2px #ccc;
        margin-left: 4%;
      }
      .ztxs{
            color: white;
            width: 50px;
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            text-align: center;
            background-color: #00DDA3;
            position: relative;
            top: 0;
            left: 0;
            float: right;
      }
      .ztxs::before{
          content: "";
            width: 0;
            height: 0;
            border-color: transparent #00DDA3;
            border-width: 0 0 6px 30px;
            border-style: solid;
            position: absolute;
            top: 20px;
            left: 0;
      }
      .ztxs::after{
        content: "";
            width: 0;
            height: 0;
            border-color: #00DDA3 transparent;
            border-width: 8px 0 0 30px;
            border-style: solid;
            position: absolute;
            top: 20px;
            left: 20px;
      }

     .yice{
           color: white;
           width: 50px;
           height: 20px;
           line-height: 20px;
           font-size: 12px;
           text-align: center;
           background-color: #FF6712;
           position: relative;
           top: 0;
           left: 0;
           float: right;
     }
     .yice::before{
         content: "";
           width: 0;
           height: 0;
           border-color: transparent #FF6712;
           border-width: 0 0 6px 30px;
           border-style: solid;
           position: absolute;
           top: 20px;
           left: 0;
     }
     .yice::after{
       content: "";
           width: 0;
           height: 0;
           border-color: #FF6712 transparent;
           border-width: 8px 0 0 30px;
           border-style: solid;
           position: absolute;
           top: 20px;
           left: 20px;
     }
     .ztxs_bt{
       width: 96%;
       font-size: 12px;
       /* padding-top: 35px; */
       /* border: solid 1px red; */
       margin: 0 auto;
       color: #666666;
       height: 50px;
       line-height: 45px;
       white-space: nowrap;
      /* border: solid 1px red; */
        overflow: hidden;  /* 超出div部分的文本隐藏 */
         text-overflow: ellipsis; /* 超出部分显示省略号 */
     }
     .ckxq{
       width: 100%;
       height: 20px;
       background-color: #00DDA3;
       color: white;
       text-align: center;
       font-size: 12px;
       line-height: 20px;
       border-radius: 0 0 5px 5px;
     }
     .zwf{
       width: 100%;
       height: 30px;
       /* border: solid 1px green; */
     }
     .rightsj{
       text-align: right;
     }
     .rwgl{
       width: 100%;
       height: auto;
       clear: both;
       /* padding-top: 10px;
       padding-bottom: 10px;
       border: solid 1px red; */
       margin-top: 15px;
     }
     .uinfo{
     	width: 94%;
       margin:  0 auto;
     	height: auto;
     	padding-top: 5px;
     	padding-bottom: 5px;
     	background-color: white;
       box-shadow: 5px 5px 5px 5px #ccc;
       border-radius: 5px 5px 5px 5px;
     }
     .uinfo_1{
     	width: 90%;
     	height: auto;
     	margin: 0 auto;

     }
     .wdbbk{
       border-bottom: none !important;
     }
     .zixun{
       width: 30%;
       height: 2rem;
       border-radius: 5px 5px 5px 5px;
       background-color: #00DDA3;
       text-align: center;
       line-height: 2rem;
       color:white;
       font-weight:bold;
      /* border: solid 1px #057E5A; */
       float: right;
      margin-top: 0.5rem;
       box-shadow: 2px 2px 2px 2px #ccc;
     }
     .kfan{
      float: right;
       height: 35px;
       width: 90px;
       text-align: center;
       color: white;
       border-radius: 10px 10px 10px 10px;
       line-height: 35px;
       margin-top: 15px;
       margin-bottom: 15px;
     }
     .ckxq{
      /* border: solid 1px red; */
       text-align: center;
       color: white;
       margin-left: 15px;
       background-color: #FF78AB;
       font-size: 14px;
        /* border: solid 1px #A72C03; */
     }
     .scan{
       margin-left: 30px;
       /* border: solid 1px green; */
      /* background-color: #FF6712; */

       background-color: #31A9FF;
     }
</style>



// WEBPACK FOOTER //
// src/views/user/kefu.vue